import { defineSlotRecipe } from '@chakra-ui/react';

const Switch = defineSlotRecipe({
  slots: ['root', 'label', 'indicator', 'control', 'thumb'],
  base: {
    thumb: {
      bg: 'white',
      boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.3);',
      width: 'var(--switch-height)',
      height: 'var(--switch-height)',
    },
    control: {
      bg: 'podcastShade400',
      p: 0,
      _focus: {
        boxShadow: '0px 0px 0px 2px rgba(160, 160, 160, 0.5)',
      },
      _checked: {
        bg: 'podcastPurple',
        _focus: {
          boxShadow: '0px 0px 0px 2px rgba(101, 85, 205, 0.5)',
        },
        _invalid: {
          bg: 'podcastRed600',
        },
      },
      _invalid: {
        bg: 'podcastRed400',
        _focus: {
          boxShadow: '0px 0px 0px 2px rgba(255, 100, 100, 0.5)',
        },
      },
    },
  },
  defaultVariants: {
    // @ts-ignore: 'variant' is a valid property for Switch, and we need to
    // set it to something other than 'solid' to use our custom colors.
    variant: 'none',
  },
});

export default Switch;
